<template>
    <div class="position-relative">
        <div class="d-flex flex-row p-3">
            <div class="d-flex flex-column w-100 me-3">
                <input class="form-control form-control-sm" type="text" id="new_collection_name" name="name" v-model="form.name" placeholder="Collection Name" aria-label="Collection Name">
                <input class="form-control form-control-sm mt-1" type="text" id="new_collection_desc" name="description" v-model="form.description" placeholder="Description" aria-label="Description">
            </div>
            <div class="btn-group" role="group" aria-label="Basic example">
                <button class="btn btn-primary btn-xs align-self-center" @click="submit">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                </button>
                <button class="btn btn-light btn-xs align-self-center" @click="emit('closed')">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20" height="20">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
        <div v-if="error">
            <span class="text-danger text-sm">{{ error }}</span>
        </div>
    </div>
</template>

<script setup>

import { ref } from 'vue';

const emit = defineEmits(['created', 'closed'])

const form = ref({
    name: null,
    description: null,
})

const error = ref(false)

const submit = () => {
    axios.post('/collections', form.value)
        .then(response => {
            emit('created')
        })
        .catch(err => {
            console.error(err)
            console.trace(err)

            if (err?.response?.data) {
                error = err?.response?.data?.message
            }
        })
}
</script>

<style scoped>
    .btn-xs {
        --bs-btn-padding-y: 0.1rem;
        --bs-btn-padding-x: 0.25rem;
        --bs-btn-font-size: 0.6rem;
        --bs-btn-border-radius: var(--bs-border-radius-sm);
    }
</style>
